import React from 'react'
import { EyeOutlined } from '@ant-design/icons'

interface ImagePreviewMaskContentProps {
    label: React.ReactNode
}

interface ImagePreviewHoverMaskProps extends ImagePreviewMaskContentProps {
    visible: boolean
}

export const ImagePreviewMaskContent: React.FC<
    ImagePreviewMaskContentProps
> = ({ label }) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            lineHeight: 1.4,
        }}
    >
        <span data-testid="image-preview-mask-icon" aria-hidden="true">
            <EyeOutlined />
        </span>
        <span>{label}</span>
    </span>
)

export const ImagePreviewHoverMask: React.FC<ImagePreviewHoverMaskProps> = ({
    label,
    visible,
}) => {
    if (!visible) {
        return null
    }

    return (
        <div
            data-testid="image-preview-hover-mask"
            aria-hidden="true"
            style={{
                position: 'absolute',
                inset: 0,
                zIndex: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.5)',
                color: '#ffffff',
                fontSize: 16,
                pointerEvents: 'none',
            }}
        >
            <ImagePreviewMaskContent label={label} />
        </div>
    )
}
